<template>
    <div class="panel-footer">
        <slot></slot>
    </div>
</template>
<script>

export default {
}

</script>
<style lang="scss" scoped>
.panel-footer {
    padding:0.5em 1em;
    @media(prefers-color-scheme: light) {
        border-top: 1px solid color-mix(in lab, currentColor 15%, transparent);
    }

    @media(prefers-color-scheme: dark) {
        border-top: 1px solid color-mix(in lab, currentColor 18%, transparent);
    }
}



</style>